import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { IntegrationsApi, RequestStrategyEnum, type WithSignal, type IntegrationResponse } from '@shared/api';

const getInitialIntegrationsEffect = createEffect(({ signal }: WithSignal = {}) => IntegrationsApi.getIntegrations(signal));
const getIntegrationsEffect = createEffect(({ signal }: WithSignal = {}) => IntegrationsApi.getIntegrations(signal));
const clearEvent = createEvent();

const $dataStore = createStore<IntegrationResponse[]>([])
  .on(getInitialIntegrationsEffect.done, (current, data) => data.result.data ?? current)
  .on(getIntegrationsEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getInitialIntegrationsEffect.pending, (_, data) => data)
  .on(getInitialIntegrationsEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getInitialIntegrationsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getInitialIntegrationsEffect, () => null)
  // .on(getInitialIntegrationsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getInitialIntegrationsEffect.fail, () => 'Something went wrong while fetching Integrations. Please try again.')
  .on(getInitialIntegrationsEffect.done, () => null)
  .on(getIntegrationsEffect, () => null)
  // .on(getIntegrationsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getIntegrationsEffect.fail, () => 'Something went wrong while fetching Integrations. Please try again.')
  .on(getIntegrationsEffect.done, () => null)
  .reset(clearEvent);

const getInitialIntegrationsApi = ApiUtilsV2.wrapperApi(getInitialIntegrationsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getInitialIntegrationsApi.cancel());

export const $integrationsStore = {
  events: {
    getInitialIntegrations: getInitialIntegrationsApi.trigger,
    getIntegrations: ApiUtilsV2.wrapperApi(getIntegrationsEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
